export const arrayToRecord =
  <TKey extends keyof any, TValue, TItem>(
    getKey: (item: TItem) => TKey,
    getValue: (item: TItem) => TValue,
  ) =>
  (array: TItem[]): Record<TKey, TValue> =>
    array.reduce(
      (acc, item) => {
        acc[getKey(item)] = getValue(item);
        return acc;
      },
      {} as Record<TKey, TValue>,
    );
